import { render, staticRenderFns } from "./ClassView.vue?vue&type=template&id=9e331804&"
import script from "./ClassView.ts?vue&type=script&lang=ts&"
export * from "./ClassView.ts?vue&type=script&lang=ts&"
import style0 from "./ClassView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports